import React from 'react';
import { I18n as I } from 'react-redux-i18n';

import { bind } from 'vdlib';
import Portlet from '../layout/Portlet';

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      oldPassword: '',
      newPassword: '',
      message: '',
    };

    bind(this, ['onChange', 'handleSubmit']);
  }

  onChange(input, e) {
    this.setState({
      message: '',
      [input]: this[`_${input}Ref`].value,
    });
  }

  handleSubmit(e) {
    if (e && e.preventDefault) e.preventDefault();

    this.props.onChangePassword(this.state.oldPassword, this.state.newPassword);
    return false;
  }

  render() {
    let buttonDisabledClass = this.props.loading ? 'disabled' : '';
    return (
      <Portlet
        title={I.t('CHANGE_PASSWORD_C')}
        icon="fa fa-key"
        bodyClassName="form"
        className="col-md-6 center"
      >
        <form
          className="form-horizontal"
          onSubmit={this.handleSubmit}
          method="post"
          noValidate={true}
        >
          <div className="form-group">
            <label className="control-label visible-ie8 visible-ie9">
              {I.t('PASSWORD_OLD')}
            </label>
            <input
              className="form-control "
              value={this.state.oldPassword}
              onChange={e => this.onChange('oldPassword', e)}
              ref={elem => (this._oldPasswordRef = elem)}
              type="password"
              autoComplete="off"
              placeholder={I.t('PASSWORD_OLD')}
              name="password"
            />
          </div>
          <div className="form-group">
            <label className="control-label visible-ie8 visible-ie9">
              {I.t('PASSWORD_NEW')}
            </label>
            <input
              className="form-control"
              value={this.state.newPassword}
              onChange={e => this.onChange('newPassword', e)}
              ref={elem => (this._newPasswordRef = elem)}
              type="password"
              autoComplete="off"
              placeholder={I.t('PASSWORD_NEW')}
              name="password"
            />
          </div>
          <div className="form-actions">
            <button
              type="submit"
              className={`btn green uppercase float-right ${buttonDisabledClass}`}
              disabled={this.props.loading}
            >
              {I.t('CHANGE_C')}
            </button>
            <div className="clear" />
          </div>
        </form>
      </Portlet>
    );
  }
}

export default ChangePassword;
